"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Image_1 = require("./Image");

var Video_1 = require("./Video");

var Device = function Device(props) {
  return React.createElement(DeviceWrapper, __assign({}, props), React.createElement(PositionHelper, null, React.createElement(MediaWrapper, __assign({}, props), props.children)));
};

Device.defaultProps = {
  borderColor: "#CECECE",
  borderSize: 3,
  mediaPosition: {
    screenW: 826,
    containerW: 1067,
    containerH: 2106,
    screenOffsetX: 116,
    screenOffsetY: 228
  }
};
exports["default"] = Device;

var heightWidthRatio = function heightWidthRatio(_a) {
  var mediaPosition = _a.mediaPosition;
  return mediaPosition.containerH / mediaPosition.containerW * 100;
};

var screenContainerWRatio = function screenContainerWRatio(_a) {
  var mediaPosition = _a.mediaPosition;
  return mediaPosition.screenW / mediaPosition.containerW * 100;
};

var screenXOffset = function screenXOffset(_a) {
  var mediaPosition = _a.mediaPosition,
      borderSize = _a.borderSize;
  return (mediaPosition.screenOffsetX - 2 * borderSize) / mediaPosition.containerW * 100;
};

var screenYOffset = function screenYOffset(_a) {
  var mediaPosition = _a.mediaPosition,
      borderSize = _a.borderSize;
  return (mediaPosition.screenOffsetY - 2 * borderSize) / mediaPosition.containerH * 100;
};

var DeviceWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: ", "%;\n  background-image: url(", ");\n  background-size: cover;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: ", "%;\n  background-image: url(", ");\n  background-size: cover;\n"])), heightWidthRatio, function (_a) {
  var casing = _a.casing;
  return "" + casing;
});
var PositionHelper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var MediaWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  width: ", "%;\n  left: ", "%;\n  top: ", "%;\n  & ", ", & ", ", & > div {\n    width: 100%;\n    height: auto;\n    border: ", "px solid\n      ", ";\n    border-radius: 2px;\n    box-sizing: content-box;\n  }\n"], ["\n  position: relative;\n  width: ", "%;\n  left: ", "%;\n  top: ", "%;\n  & ", ", & ", ", & > div {\n    width: 100%;\n    height: auto;\n    border: ", "px solid\n      ", ";\n    border-radius: 2px;\n    box-sizing: content-box;\n  }\n"])), screenContainerWRatio, screenXOffset, screenYOffset, Image_1.ImageStyled, Video_1.VideoStyled, function (_a) {
  var borderSize = _a.borderSize;
  return borderSize;
}, function (_a) {
  var borderColor = _a.borderColor;
  return borderColor;
});
var templateObject_1, templateObject_2, templateObject_3;